import React, { Component } from 'react';
import _ from 'lodash';

import FullHistoryStructure from '../components/FullHistory/FullHistoryStructure';
import RenderWorkflowProcessHistory from '../components/FullHistory/RenderWorkflowProcessHistory';
import Loading from '../components/Loading';

import WorkflowProcessStore from '../stores/WorkflowProcessStore';
import WorkflowProcessHistoryStore from '../stores/WorkflowProcessHistoryStore';

class FullHistoryPage extends Component {
  constructor(props){
    super(props)

    this.state = {
      loading: false,
      workflow_process_id: this.props.match.params.workflow_process_id,
      current_department: "",
      current_state_name: "",
      all_history: [],
      current_workflow_state_attributes: {},
      focus_workflow_process_history: {},
      active_history: ""
    }

    this.loadData = this.loadData.bind(this);
    this.handleFocusHistory = this.handleFocusHistory.bind(this);
    this.handleFocusCampusHistory = this.handleFocusCampusHistory.bind(this);
  }

  componentWillMount() {
    this.loadData()
  }

  loadData(){
    this.setState({loading: true});
    WorkflowProcessStore.request({id: this.state.workflow_process_id, action: 'full_history'}).then((resp)=>{
      const {current_department, current_state_name, all_history} = resp.data.data;
      const current_workflow_state_attributes = resp.data.current_workflow_state_attributes;

      this.setState({
        current_department: current_department,
        current_state_name: current_state_name,
        all_history: all_history,
        focus_workflow_process_history: current_workflow_state_attributes,
        active_history: `wp-${this.state.workflow_process_id}-history-null`
      })
    }).then(()=>{
      this.setState({loading: false});
    })
  }

  handleFocusHistory(history_row, event){
    event.stopPropagation();
    const self = this;

    if(_.isEmpty(history_row.wph_id)){

      this.setState({loading: true});
      WorkflowProcessStore.request({id: history_row.workflow_process_id, action: "current_workflow_state"}).then((resp)=>{
        const current_workflow_state_attributes = _.get(resp.data, 'current_workflow_state_attributes', {});

        this.setState({
          focus_workflow_process_history: current_workflow_state_attributes
        })
      }, function(error){
        self.setState({
          focus_workflow_process_history: {}, 
          loading: false
         });
      }).then(()=>{
        this.setState({
          loading: false,
          active_history: `wp-${history_row.workflow_process_id}-history-${history_row.wph_id}`
         });
      })

    } else {

      this.setState({loading: true});
      WorkflowProcessHistoryStore.request({id: history_row.wph_id}).then((resp)=>{
        const workflow_process_history = _.get(resp.data, 'workflow_process_history', {});

        this.setState({
          focus_workflow_process_history: workflow_process_history
        })
      }, function(error){
        self.setState({
          focus_workflow_process_history: {}, 
          loading: false
        });
      }).then(()=>{
        this.setState({
          loading: false,
          active_history: `wp-${history_row.workflow_process_id}-history-${history_row.wph_id}`
         });
      })
      
    }
  }

  handleFocusCampusHistory(campus_code, workflow_process_id, event){
    event.stopPropagation();
    const self = this;

    this.setState({loading: true});

    WorkflowProcessStore.request({id: workflow_process_id, action: `campus_workflow_state?campus_code=${campus_code}`}).then((resp)=>{
      const current_workflow_state_attributes = _.get(resp.data, 'current_workflow_state_attributes', {});

      this.setState({
        focus_workflow_process_history: current_workflow_state_attributes
      })
    }, function(error){
      self.setState({
        focus_workflow_process_history: {}, 
        loading: false
       });
    }).then(()=>{
      this.setState({
        loading: false,
        active_history: `wp-${workflow_process_id}-history-${campus_code}`
       });
    })
  }

  render(){
    const { 
      loading, 
      workflow_process_id, 
      current_department, 
      current_state_name, 
      all_history, 
      focus_workflow_process_history, 
      active_history
    } = this.state;

    return (
      <div className='row'>
        <div className="col-md-6" style={{fontSize: '1.1rem', height: '550px', overflowY: 'scroll', borderBottom: '1px solid lightgray'}}>
          <FullHistoryStructure 
            workflow_process_id={workflow_process_id}
            current_department={current_department}
            current_state_name={current_state_name}
            all_history={all_history}
            onFocusHistory={this.handleFocusHistory}
            onFocusCampusHistory={this.handleFocusCampusHistory}
            active_history={active_history} />
        </div>
        <div className="col-md-6 bg-white p-4 inbox-body" style={{height: '550px', overflowY: 'scroll'}}>
          {loading ? (
            <Loading />
          ) : (
            <RenderWorkflowProcessHistory
              focus_workflow_process_history={focus_workflow_process_history} />
          )}
        </div>
      </div>
    );
  }
}

export default FullHistoryPage;


// WEBPACK FOOTER //
// ./src/pages/FullHistoryPage.js